module.exports = __webpack_public_path__ + "3c7ae7ae082c67c942ead1e70a047333.svg";